import React, { useEffect, useState } from 'react';
import { fetchWabaInfo, updateWabaProfile, WabaInfo, WabaProfile } from '../../../services/whatsapp/wabaService';

export default function WabaTab() {
  const [waba, setWaba] = useState<WabaInfo | null>(null);
  const [profile, setProfile] = useState<WabaProfile>({});
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);

  useEffect(() => {
    fetchWabaInfo().then(data => {
      setWaba(data.waba);
      setProfile(data.profile || {});
      setLoading(false);
    }).catch(err => {
      console.error(err);
      setLoading(false);
    });
  }, []);

  const handleSave = async () => {
    setSaving(true);
    try {
      await updateWabaProfile(profile);
      alert('Profile updated');
    } catch (e) {
      alert('Error updating profile');
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-wa-muted">Loading WABA details...</div>;
  if (!waba) return <div className="text-red-400">Failed to load WABA details. Check configuration.</div>;

  return (
    <div className="space-y-6">
      <h3 className="text-white font-medium mb-4">WhatsApp Business Account (WABA)</h3>
      
      <div className="bg-wa-surface2 border border-wa-border p-4 rounded text-sm mb-6">
        <p className="text-wa-muted mb-2">Account ID: <span className="text-white font-mono">{waba.id}</span></p>
        <p className="text-wa-muted">Name: <span className="text-white">{waba.name}</span></p>
      </div>

      <div className="space-y-4 max-w-lg">
        <h4 className="text-white font-medium border-b border-wa-border pb-2">Business Profile</h4>
        
        <div>
          <label className="block text-wa-muted text-xs mb-1">Description</label>
          <textarea 
            value={profile.description || ''} 
            onChange={e => setProfile({...profile, description: e.target.value})}
            className="w-full bg-wa-surface border border-wa-border rounded text-white p-2 text-sm"
            rows={3}
          />
        </div>

        <div>
          <label className="block text-wa-muted text-xs mb-1">About (Status)</label>
          <input 
            type="text" 
            value={profile.about || ''} 
            onChange={e => setProfile({...profile, about: e.target.value})}
            className="w-full bg-wa-surface border border-wa-border rounded text-white p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-wa-muted text-xs mb-1">Address</label>
          <input 
            type="text" 
            value={profile.address || ''} 
            onChange={e => setProfile({...profile, address: e.target.value})}
            className="w-full bg-wa-surface border border-wa-border rounded text-white p-2 text-sm"
          />
        </div>

        <div>
          <label className="block text-wa-muted text-xs mb-1">Email</label>
          <input 
            type="email" 
            value={profile.email || ''} 
            onChange={e => setProfile({...profile, email: e.target.value})}
            className="w-full bg-wa-surface border border-wa-border rounded text-white p-2 text-sm"
          />
        </div>
        
        <button 
          onClick={handleSave} 
          disabled={saving}
          className="bg-wa-green text-gray-900 px-4 py-2 rounded font-medium disabled:opacity-50 mt-4"
        >
          {saving ? 'Saving...' : 'Save Profile'}
        </button>
      </div>
    </div>
  );
}
